import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  open: {
    id: 'react-components.bdcMGy',
    defaultMessage: 'Open menu',
  },
  close: {
    id: 'react-components.dg8ZEb',
    defaultMessage: 'Close menu',
  },
});
